import { isPostHogCapturing } from '@/lib/posthog';
import { trackEvent } from '@/lib/trackEvent';
import { markReportOpenedAt } from '@/lib/reportScrolled';
import { buildReportTrafficProperties } from '@/lib/trafficChannel';

const SESSION_STORAGE_KEY_PREFIX = 'ph_report_open_events:';

const getSessionKey = (reportId: string): string =>
  `${SESSION_STORAGE_KEY_PREFIX}${reportId}`;

export const hasTrackedReportOpenEvents = (reportId: string): boolean => {
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(getSessionKey(reportId)) === '1';
};

export const trackReportOpenEvents = (
  reportId: string,
  extra?: Record<string, unknown>
): boolean => {
  if (!reportId || !isPostHogCapturing()) return false;
  if (hasTrackedReportOpenEvents(reportId)) return false;

  const { sourceIdentified, opened } = buildReportTrafficProperties();

  const sourceTracked = trackEvent('report_source_identified', {
    ...sourceIdentified,
    ...extra,
  });
  const openedTracked = trackEvent('report_opened', {
    ...opened,
    ...extra,
  });

  if (sourceTracked && openedTracked) {
    markReportOpenedAt(reportId);
    sessionStorage.setItem(getSessionKey(reportId), '1');
    return true;
  }

  return false;
};
